import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  // root: {
  //   // marginTop: theme.spacing(2),
  //   // marginBottom: theme.spacing(8),
  //   // height: "100%"
  // },
  backgrounplans: {
    zIndex: -1,
    position: "absolute",
    top: "60px",
    backgroundSize: "cover",
    backgroundImage:
      "linear-gradient(rgba(41, 67, 116, 0.7), rgba(41, 67, 116, 0.7)), url('/images/services/backgroundServices.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    width: "100%",
    //height: "485px",
    height: "calc(100% - 60px)",
  },
  paperContent: {
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(10),
    [theme.breakpoints.up("sm")]: {
      marginTop: theme.spacing(30),
    },
  },
  containertittle: {
    height: "100%",
  },
  gridtittle: {
    paddingBottom: theme.spacing(15),
    paddingTop: theme.spacing(15),
    //height: 'calc(100% - 100px)',
    minHeight: 550,
    [theme.breakpoints.up("sm")]: {
      //height: 'calc(100% - 400px)',
      minHeight: 400,
      paddingBottom: theme.spacing(20),
      paddingTop: theme.spacing(20),
    },
    [theme.breakpoints.down(321)]: {
      //height: 'calc(100% - 400px)',
      minHeight: 400,
      paddingBottom: theme.spacing(6),
      paddingTop: theme.spacing(6),
    },
  },
  tittleservicepage: {
    fontWeight: "bold",
    color: "#33658A",
    fontFamily: "Century-Gothic",
    marginBottom: theme.spacing(3),
  },
  subtittleservicepage: {
    //fontWeight: 'bold',
    color: "#33658A",
    fontFamily: "Century-Gothic",
    marginBottom: theme.spacing(3),
  },
  arrowicon: {
    marginTop: theme.spacing(2),
    width: theme.spacing(5),
    height: theme.spacing(5),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(8),
      height: theme.spacing(8),
      marginTop: theme.spacing(12),
    },
  },

  ContainerServiceOne: {
    backgroundSize: "cover",
    backgroundImage:
      "linear-gradient(rgba(51, 101, 138, 0.7), rgba(51, 101, 138, 0.7)), url('/images/services/man2.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(4),
    borderBottom: "5px solid white",
  },
  ContainerServiceTwo: {
    backgroundSize: "cover",
    backgroundImage:
      "linear-gradient(rgba(35, 37, 41, 0.74), rgba(35, 37, 41, 0.74)), url('/images/services/man5.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(4),
    borderBottom: "5px solid white",
  },
  ContainerServiceTree: {
    backgroundSize: "cover",
    backgroundImage:
      "linear-gradient(rgba(41, 67, 116, 0.76), rgba(41, 67, 116, 0.76)), url('/images/services/man3.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(4),
    borderBottom: "5px solid white",
  },
  ContainerServiceFour: {
    backgroundSize: "cover",
    backgroundImage:
      "linear-gradient(rgba(35, 37, 41, 0.74), rgba(35, 37, 41, 0.74)), url('/images/services/man4.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(4),
    borderBottom: "5px solid white",
  },
  ContainerServiceFive: {
    backgroundSize: "cover",
    backgroundImage:
      "linear-gradient(rgba(51, 101, 138, 0.7), rgba(51, 101, 138, 0.7)), url('/images/services/man1.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(4),
    borderBottom: "5px solid white",
  },
  ContainerServiceSix: {
    backgroundSize: "cover",
    backgroundImage:
      "linear-gradient(rgba(35, 37, 41, 0.74), rgba(35, 37, 41, 0.74)), url('/images/services/man7.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(4),
    borderBottom: "5px solid white",
  },
  ContainerServiceSeven: {
    backgroundSize: "cover",
    backgroundImage:
      "linear-gradient(rgba(41, 67, 116, 0.76), rgba(41, 67, 116, 0.76)), url('/images/services/man6.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(4),
    borderBottom: "5px solid white",
  },
  ContainerServiceEight: {
    backgroundSize: "cover",
    backgroundImage:
      "linear-gradient(rgba(35, 37, 41, 0.74), rgba(35, 37, 41, 0.74)), url('/images/services/man8.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(4),
  },
  tittleservice: {
    fontWeight: "bold",
    color: "white",
    fontFamily: "Century-Gothic",
    marginBottom: theme.spacing(3),
  },
  itemservice: {
    //fontWeight: 'bold',
    color: "white",
    fontFamily: "Century-Gothic",
    paddingBottom: theme.spacing(2),
  },
  itemservicebold: {
    fontWeight: "bold",
    color: "white",
    fontFamily: "Century-Gothic",
    paddingBottom: theme.spacing(3),
  },
  marginproducts: {
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      paddingBottom: theme.spacing(5),
      paddingTop: theme.spacing(5),
    },
  },
  normalmargin: {
    paddingBottom: theme.spacing(5),
    paddingTop: theme.spacing(2),
  },
  matteport: {
    pointerEvents: 'none',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    borderRadius: "10px",
    width: "inherit",
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(4),
      marginTop: theme.spacing(4),
    },
  },
  tab: {
    "& > * + *": {
      marginLeft: theme.spacing(4),
      [theme.breakpoints.down("md")]: {
        marginLeft: theme.spacing(0),
      },
    },
  },
}));

export default useStyles;
